<section>
  <h1 class="evn-text-subhead-2 cg-margin-bottom-sm">
    {{ 'login.form.header' | translate }}
  </h1>
  <div class="cg-margin-top-md">
    <ng-container *ngIf="isAuthLoading$ | async; else loginForm">
      <cigna-leaf-loading-spinner
        label="Logging in..."
        size="small"
      ></cigna-leaf-loading-spinner>
    </ng-container>
    <ng-template #loginForm>
      <div class="cg-margin-top-md">
        <div class="cg-margin-bottom-md" *ngIf="authError$ | async as error">
          <cigna-leaf-field-note [isError]="true">
            {{
              error.error === 'access_denied'
                ? 'Login error The User ID and password combination you entered does not match our records. Try again or call Customer Support at 888.736.7499.'
                : error.message || error
            }}
          </cigna-leaf-field-note>
        </div>
        <button
          cignaButton="primary"
          type="submit"
          data-test="login-submit-button"
          value="Login Auth0"
          (click)="loginAuth0()"
        >
          {{ 'login.form.login' | translate }}
        </button>
        <div class="centered-pipe-text">
          {{ 'login.form.createAccount' | translate }}
        </div>
      </div>
      <div class="cg-margin-top-md">
        <a
          routerLink="/registration"
          cignaButton="secondary"
          data-test="register-button"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Register',
            'ac22394',
            {
              eVar120: 'register-button',
              eVar119: 'US1880997'
            }
          ]"
        >
          {{ 'login.form.register' | translate }}
        </a>
      </div>
      <div class="cg-margin-top-md centerAlign">
        <a
          routerLink="/registration/tempid"
          data-test="temp-id-link"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Temporary ID',
            'ac22396',
            {
              eVar120: 'temporary-id-link',
              eVar119: 'US1881001'
            }
          ]"
          >{{ 'login.form.temporaryId' | translate }}</a
        >
        <button
          class="cg-margin-left-sm"
          cignaButton="link inline no-underline"
          type="button"
          (click)="openWhatIsTemporaryIdModal()"
          data-test="login-tempid-help-link"
          aria-label="What is a temporary ID"
        >
          <cigna-icon type="question-mark-circle"></cigna-icon>
        </button>
      </div>
      <div class="cg-margin-top-md centerAlign">
        <a
          data-test="how-to-register-link"
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/howToRegister'
              | resourceLink : { secure: false, targetApp: 'evernorth' }
              | async
          "
          [cignaTrackClicks]="[
            'trackEventOther',
            'How to register',
            'ac22395',
            {
              eVar120: 'how-to-register-link',
              eVar119: 'US1880999'
            }
          ]"
          >{{ 'login.form.howTo' | translate }}</a
        >
      </div>
    </ng-template>
  </div>
</section>
